// extracted by mini-css-extract-plugin
export default {"app-install-guide-container":"clkfsXWIwMWMXFprIZMl","app-install-guide-button":"n2jKMxkwVOYX547x1G3A"};